export { default } from "./partnerInfoForm";
